"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyFontSizeMin = void 0;
var applyFontSizeMin = exports.applyFontSizeMin = function applyFontSizeMin(canvas, fontSizeMin) {
  canvas.objects.forEach(function (o) {
    if (o.type === 'Text') {
      o.fontSizeMin = fontSizeMin;
    }
  });
};